<template>
    <select v-model="input" @change="onChange($event)" class="form-control custom-select shadow-sm">
        <option :value="null" disabled selected>Select an option</option>
        <option v-for="option in countries" :data-country-iso="option.code_iso" :value="option.code" v-bind:key="option.value">{{ option.name }}</option>
    </select>
</template>

<script>
	export default {
		data() {
			return {
				input: this.countrySelected || null
			};
		},
		watch: {
			countrySelected: function(country) {
				if (country) {
					const filteredCountry = this.filterCountries(country);

					this.input = filteredCountry.code;

					this.$emit("update-country", {
						code: filteredCountry.code,
						iso: filteredCountry.code_iso
					});
				}
			}
		},
		methods: {
			filterCountries(params) {
				return _.head(
					this.countries.filter(country => {
						return (
							country.code === params || country.code_iso === params
						);
					})
				);
			},
			onChange(event) {
				let country = {
					code: event.target.value,
					iso:
						event.target.options[event.target.options.selectedIndex]
							.dataset.countryIso
				};

				this.$emit("update-country", country);
			}
		},
		props: ["countries", "countrySelected"]
	};
</script>
